
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/turnaje/[id]",
      function () {
        return require("private-next-pages/turnaje/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/turnaje/[id]"])
      });
    }
  